var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ShareSpaceModel } from '../../models/share-space-model';
import { Emitter } from '@patsnap/tahiti-core';
import { ShareSettingsRepository } from '../share-settings-repository';
let ShareSettingsServiceImpl = class ShareSettingsServiceImpl {
    constructor(_shareSettingsRepository, _shareSpaceModel) {
        this._shareSettingsRepository = _shareSettingsRepository;
        this._shareSpaceModel = _shareSpaceModel;
        this._onDidSwitchSharePublicEmitter = new Emitter();
    }
    get onDidSwitchSharePublic() {
        return this._onDidSwitchSharePublicEmitter.event;
    }
    async getShareSettings(data) {
        const result = await this._shareSettingsRepository.getShareSettings(data);
        return result;
    }
    createShareCode(data) {
        const { shareExpiryAt, syncDisplayField, type, } = this._shareSpaceModel.modelData;
        const options = {
            ...data,
            shareExpiryAt,
            syncDisplayField,
            type,
        };
        return this._shareSettingsRepository.createShareCode(options);
    }
    switchSharePublic(options) {
        return this._shareSettingsRepository.switchSharePublic(options).then((_) => {
            this._onDidSwitchSharePublicEmitter.fire(_);
            return _;
        });
    }
};
ShareSettingsServiceImpl = __decorate([
    injectable(),
    __param(0, inject(ShareSettingsRepository)),
    __param(1, inject(ShareSpaceModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof ShareSettingsRepository !== "undefined" && ShareSettingsRepository) === "function" ? _a : Object, typeof (_b = typeof ShareSpaceModel !== "undefined" && ShareSpaceModel) === "function" ? _b : Object])
], ShareSettingsServiceImpl);
export { ShareSettingsServiceImpl };
